import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Target, Award, Users, Heart, Wrench, Clock } from 'lucide-react';
import { contactInfo, stats } from '../mockData';

const About = () => {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="about-hero-content fade-in">
            <h1 className="page-title">
              <span className="text-yellow">NDV MOTORS</span><br />
              L'Excellence Automobile
            </h1>
            <p className="page-subtitle">
              Votre partenaire de confiance pour la carrosserie, la peinture et la rénovation automobile à Yutz depuis plus de 10 ans.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-padding">
        <div className="container">
          <div className="story-grid">
            <div className="story-image slide-in-left">
              <img
                src="https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/yxy0zjcb_WhatsApp%20Image%202024-09-06%20%C3%A0%2008.23.30_62fb9842.jpg"
                alt="NDV Motors Garage"
              />
            </div>
            <div className="story-content slide-in-right">
              <h2 className="section-title">
                Notre <span className="text-yellow">Histoire</span>
              </h2>
              <p className="story-text">
                NDV Motors est né d'une passion pour l'automobile et d'un désir d'offrir un service 
                de qualité supérieure aux propriétaires de véhicules en Moselle. Situé à Yutz, notre 
                garage s'est rapidement imposé comme une référence dans le domaine de la carrosserie 
                et de la peinture automobile.
              </p>
              <p className="story-text">
                Avec 5 ans d'expérience et plus de 30 véhicules traités chaque semaine, nous 
                avons développé une expertise unique qui nous permet de prendre en charge tous types de 
                travaux, des réparations après sinistre aux projets de rénovation complète.
              </p>
              <p className="story-text">
                <strong className="text-yellow">Agréé par les principales compagnies d'assurance</strong> (Groupama, Allianz, Macif, L'Olivier, GAN, AXA, Maif, Matmut), 
                nous disposons également d'un parc de <strong className="text-yellow">15 véhicules de prêt 
                catégories A, B et C</strong> pour vous garantir une mobilité permanente pendant la durée 
                des travaux.
              </p>
              <p className="story-text">
                Notre engagement : allier passion de l'automobile, précision technique et satisfaction 
                client pour offrir un service d'excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section section-padding">
        <div className="container">
          <div className="section-header text-center mb-60">
            <h2 className="section-title">
              Nos <span className="text-yellow">Valeurs</span>
            </h2>
            <p className="section-subtitle">
              Les principes qui guident notre travail au quotidien
            </p>
          </div>
          <div className="values-grid">
            <div className="value-card fade-in">
              <div className="value-icon">
                <Award size={48} />
              </div>
              <h3 className="value-title">Excellence</h3>
              <p className="value-text">
                Chaque véhicule bénéficie de notre savoir-faire et de notre attention aux détails. 
                Nous ne transigeons jamais sur la qualité.
              </p>
            </div>
            <div className="value-card fade-in" style={{ animationDelay: '0.1s' }}>
              <div className="value-icon">
                <Heart size={48} />
              </div>
              <h3 className="value-title">Passion</h3>
              <p className="value-text">
                L'automobile est notre passion. Nous traitons chaque véhicule comme s'il était le nôtre, 
                avec soin et dévouement.
              </p>
            </div>
            <div className="value-card fade-in" style={{ animationDelay: '0.2s' }}>
              <div className="value-icon">
                <Target size={48} />
              </div>
              <h3 className="value-title">Précision</h3>
              <p className="value-text">
                Du diagnostic à la livraison, chaque étape est exécutée avec une précision millimétrique 
                pour des résultats impeccables.
              </p>
            </div>
            <div className="value-card fade-in" style={{ animationDelay: '0.3s' }}>
              <div className="value-icon">
                <Users size={48} />
              </div>
              <h3 className="value-title">Satisfaction Client</h3>
              <p className="value-text">
                Votre satisfaction est notre priorité absolue. Nous sommes à l'écoute et adaptons nos 
                services à vos besoins.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="expertise-section section-padding">
        <div className="container">
          <div className="expertise-grid">
            <div className="expertise-content slide-in-left">
              <h2 className="section-title">
                Notre <span className="text-yellow">Expertise</span>
              </h2>
              <p className="expertise-intro">
                NDV Motors dispose d'équipements professionnels de dernière génération pour garantir 
                des résultats à la hauteur de vos attentes.
              </p>
              <div className="expertise-features">
                <div className="expertise-item">
                  <Wrench className="expertise-icon" size={32} />
                  <div>
                    <h3 className="expertise-item-title">Équipement Professionnel</h3>
                    <p className="expertise-item-text">
                      Cabine de peinture professionnelle, outils de redressage de précision, 
                      équipements de polissage haut de gamme.
                    </p>
                  </div>
                </div>
                <div className="expertise-item">
                  <Target className="expertise-icon" size={32} />
                  <div>
                    <h3 className="expertise-item-title">Finitions Impeccables</h3>
                    <p className="expertise-item-text">
                      Chaque détail compte. Nos finitions sont soignées et nos teintes parfaitement 
                      ajustées pour un résultat invisible.
                    </p>
                  </div>
                </div>
                <div className="expertise-item">
                  <Clock className="expertise-icon" size={32} />
                  <div>
                    <h3 className="expertise-item-title">Délais Respectés</h3>
                    <p className="expertise-item-text">
                      Nous nous engageons sur des délais réalistes et faisons tout pour les respecter, 
                      sans compromis sur la qualité.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="expertise-images slide-in-right">
              <div className="expertise-image-main">
                <img
                  src="https://customer-assets.emergentagent.com/job_ndvmotors/artifacts/fx3iqcqm_4acf64880a571d27dd95d92d05edeb815a9085b1.jpg"
                  alt="Showroom Jantes NDV Motors"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="about-stats-section section-padding">
        <div className="container">
          <div className="about-stats-grid">
            {stats.map((stat, index) => (
              <div
                key={stat.id}
                className="about-stat-card fade-in"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="about-stat-number">{stat.number}</div>
                <div className="about-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="about-cta section-padding">
        <div className="container">
          <div className="about-cta-content">
            <h2 className="cta-title fade-in">
              Rejoignez Nos Clients Satisfaits
            </h2>
            <p className="cta-subtitle slide-in-left">
              Découvrez pourquoi tant de propriétaires nous font confiance pour leurs véhicules
            </p>
            <div className="cta-buttons slide-in-right">
              <Link to="/contact" className="btn-primary">
                Contactez-Nous
                <ArrowRight size={20} />
              </Link>
              <Link to="/galerie" className="btn-secondary">
                Voir Notre Galerie
              </Link>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        /* Hero Section */
        .about-hero {
          background: linear-gradient(135deg, var(--bg-page) 0%, var(--bg-card) 100%);
          padding: 160px 40px 80px;
          border-bottom: 3px solid var(--brand-yellow);
        }

        .about-hero-content {
          max-width: 900px;
          margin: 0 auto;
          text-align: center;
        }

        .page-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2.5rem, 6vw, 5rem);
          line-height: 1.1;
          color: var(--text-primary);
          margin-bottom: 24px;
        }

        .page-subtitle {
          font-size: clamp(1rem, 2vw, 1.3rem);
          line-height: 1.7;
          color: var(--text-secondary);
          max-width: 700px;
          margin: 0 auto;
        }

        /* Story Section */
        .story-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 60px;
          align-items: center;
        }

        .story-image img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          border-radius: var(--radius-lg);
          border: 3px solid var(--brand-yellow);
        }

        .section-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2rem, 4vw, 3rem);
          line-height: 1.2;
          color: var(--text-primary);
          margin-bottom: 24px;
        }

        .story-text {
          font-size: 1.1rem;
          line-height: 1.8;
          color: var(--text-secondary);
          margin-bottom: 20px;
        }

        /* Values Section */
        .values-section {
          background: var(--bg-card);
        }

        .section-subtitle {
          font-size: 1.2rem;
          color: var(--text-secondary);
          max-width: 600px;
          margin: 0 auto;
        }

        .values-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 32px;
        }

        .value-card {
          background: var(--bg-page);
          padding: 40px 32px;
          border-radius: var(--radius-lg);
          border: 2px solid var(--border-light);
          text-align: center;
          transition: all 0.3s ease;
        }

        .value-card:hover {
          border-color: var(--brand-yellow);
          transform: translateY(-8px);
          box-shadow: 0 10px 30px rgba(255, 193, 7, 0.2);
        }

        .value-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 100px;
          height: 100px;
          margin: 0 auto 24px;
          background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-dark) 100%);
          color: var(--brand-black);
          border-radius: 50%;
          transition: transform 0.3s ease;
        }

        .value-card:hover .value-icon {
          transform: scale(1.1) rotate(5deg);
        }

        .value-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          font-size: 1.5rem;
          color: var(--brand-yellow);
          margin-bottom: 16px;
        }

        .value-text {
          font-size: 1rem;
          line-height: 1.6;
          color: var(--text-secondary);
        }

        /* Expertise Section */
        .expertise-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
          gap: 60px;
          align-items: center;
        }

        .expertise-intro {
          font-size: 1.2rem;
          line-height: 1.7;
          color: var(--text-secondary);
          margin-bottom: 32px;
        }

        .expertise-features {
          display: flex;
          flex-direction: column;
          gap: 32px;
        }

        .expertise-item {
          display: flex;
          gap: 20px;
          align-items: flex-start;
        }

        .expertise-icon {
          color: var(--brand-yellow);
          flex-shrink: 0;
          margin-top: 4px;
        }

        .expertise-item-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 700;
          font-size: 1.3rem;
          color: var(--brand-yellow);
          margin-bottom: 8px;
        }

        .expertise-item-text {
          font-size: 1rem;
          line-height: 1.6;
          color: var(--text-secondary);
        }

        .expertise-image-main img {
          width: 100%;
          height: 500px;
          object-fit: cover;
          border-radius: var(--radius-lg);
          border: 3px solid var(--brand-yellow);
        }

        /* Stats Section */
        .about-stats-section {
          background: var(--bg-card);
        }

        .about-stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 40px;
        }

        .about-stat-card {
          text-align: center;
          padding: 32px 20px;
          background: var(--bg-page);
          border-radius: var(--radius-lg);
          border: 2px solid var(--border-light);
          transition: all 0.3s ease;
        }

        .about-stat-card:hover {
          border-color: var(--brand-yellow);
          transform: translateY(-4px);
        }

        .about-stat-number {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2.5rem, 5vw, 4rem);
          color: var(--brand-yellow);
          line-height: 1;
          margin-bottom: 12px;
        }

        .about-stat-label {
          font-size: 1rem;
          color: var(--text-secondary);
          font-weight: 500;
        }

        /* CTA Section */
        .about-cta {
          background: linear-gradient(135deg, var(--brand-yellow) 0%, var(--brand-yellow-dark) 100%);
        }

        .about-cta-content {
          text-align: center;
          max-width: 800px;
          margin: 0 auto;
        }

        .cta-title {
          font-family: 'Montserrat', sans-serif;
          font-weight: 900;
          font-size: clamp(2rem, 4vw, 3.5rem);
          color: var(--brand-black);
          margin-bottom: 20px;
        }

        .cta-subtitle {
          font-size: 1.3rem;
          color: var(--brand-black);
          margin-bottom: 40px;
          opacity: 0.9;
        }

        .cta-buttons {
          display: flex;
          gap: 20px;
          justify-content: center;
          flex-wrap: wrap;
        }

        .about-cta .btn-primary {
          background: var(--brand-black);
          color: var(--brand-yellow);
        }

        .about-cta .btn-primary:hover {
          background: var(--brand-black-light);
        }

        .about-cta .btn-secondary {
          background: transparent;
          color: var(--brand-black);
          border-color: var(--brand-black);
        }

        .about-cta .btn-secondary:hover {
          background: var(--brand-black);
          color: var(--brand-yellow);
        }

        /* Responsive */
        @media (max-width: 767px) {
          .about-hero {
            padding: 120px 20px 60px;
          }

          .story-grid,
          .expertise-grid {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .story-image img,
          .expertise-image-main img {
            height: 350px;
          }

          .values-grid {
            grid-template-columns: 1fr;
          }

          .about-stats-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 24px;
          }

          .cta-buttons {
            flex-direction: column;
          }
        }
      `}</style>
    </div>
  );
};

export default About;
